module.exports = __webpack_public_path__ + "img/pr-21.4be66329.png";